import { render, staticRenderFns } from "./creatGoodDetailsAgain.vue?vue&type=template&id=48f7afe7"
import script from "./creatGoodDetailsAgain.vue?vue&type=script&lang=js"
export * from "./creatGoodDetailsAgain.vue?vue&type=script&lang=js"
import style0 from "./creatGoodDetailsAgain.vue?vue&type=style&index=0&id=48f7afe7&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports